import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { type FunctionComponent } from 'react'

import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import SearchSuggestionName from 'views/components/organisms/SearchBox/SearchBoxListItem/SearchSuggestionName'

import './SearchHistory.scss'

type SearchHistoryProps = {
  searchHistory: string[]
  handleClearHistory?: () => true
  handleQueryUpdate: (query: string) => void
  fromPreQuerySuggestions?: boolean
}

const SearchHistory: FunctionComponent<SearchHistoryProps> = ({
  searchHistory,
  handleClearHistory,
  handleQueryUpdate,
  fromPreQuerySuggestions,
}) => {
  const handleClick = (event: Event) => {
    event.stopPropagation()
    event.preventDefault()

    if (handleClearHistory) {
      handleClearHistory()
    }
  }

  const className = classNames('u-text-align--left u-padding', {
    'o-SearchHistory': !fromPreQuerySuggestions,
    'o-SearchHistory--fromPreQuerySuggestions': true,
  })
  const deleteSearchHistoryButton = (
    <ButtonAsLink name="searchistory-delete" onClick={handleClick}>
      <span
        className={classNames('o-SearchBox__SearchHistory__link', {
          'u-text-transform--lowercase ': !fromPreQuerySuggestions,
          'u-font-weight--bold': fromPreQuerySuggestions,
        })}
      >
        <Trans id="general.button.delete" />
      </span>
    </ButtonAsLink>
  )

  return (
    <div className={className}>
      {!fromPreQuerySuggestions && (
        <div className="l-flex">
          <div className="l-flex__primary">
            <div className="o-SearchBox__top-searches-product__title u-font-weight--bold">
              <Trans id="searchBox.label.lastSearched" />
            </div>
          </div>
          <div>{deleteSearchHistoryButton}</div>
        </div>
      )}
      {fromPreQuerySuggestions && (
        <div className="o-SearchBox__top-searches-product__title u-font-weight--bold">
          <Trans id="searchBox.label.lastSearched" />
        </div>
      )}

      {searchHistory.length > 0 && (
        <ul className="o-SearchHistory__list a-list-reset u-padding--top">
          {searchHistory.map((query, index) => (
            <li
              className="a-link o-SearchHistory__list-item__wrapper u-padding-xx-small--ends"
              key={`searchistory-link-${index}`}
            >
              <ButtonAsLink
                name={`searchistory-link-${index}`}
                neutral
                onClick={() => handleQueryUpdate(query)}
                left
                fullWidth
                className="o-SearchHistory__list-item"
                data-clientside-hook="SearchBoxListHistoryLink"
              >
                <span className="o-SearchBox__label">
                  <SearchSuggestionName name={query} />
                </span>
              </ButtonAsLink>
            </li>
          ))}
          {fromPreQuerySuggestions && (
            <li className="u-padding-xx-small--ends">
              {deleteSearchHistoryButton}
            </li>
          )}
        </ul>
      )}
    </div>
  )
}

export default SearchHistory
